import React from 'react';
// Styles
import './Tabs.css';
export const Tabs = ({ tabs, selected, onChange }) => {
    return (React.createElement("ul", { className: "multifarm-hybrid-finance__tabs" }, tabs.map((item, index) => (React.createElement("li", { key: `tab-${index}`, className: "multifarm-hybrid-finance__tabs-item" },
        React.createElement("button", { className: "multifarm-hybrid-finance__tabs-button", "data-active": selected === item.value, type: "button", onClick: () => onChange(item.value) }, item.name))))));
};
